export default __webpack_public_path__ + "static/media/seoul.3f0de7be.png";